import React, {useRef, forwardRef, useState, useEffect, Fragment} from 'react'
import {useDispatch, useSelector} from "react-redux"
import MaterialTable from 'material-table'

// Material-UI Core
import {makeStyles} from '@material-ui/core/styles'

// Material-UI Lab
// import ToggleButton from '@material-ui/lab/ToggleButton'

// Material-UI Icon
// For Material-Table
import AddBox from '@material-ui/icons/AddBox'
import ArrowDownward from '@material-ui/icons/ArrowDownward'
import Check from '@material-ui/icons/Check'
import ChevronLeft from '@material-ui/icons/ChevronLeft'
import ChevronRight from '@material-ui/icons/ChevronRight'
import Clear from '@material-ui/icons/Clear'
import DeleteOutline from '@material-ui/icons/DeleteOutline'
import Edit from '@material-ui/icons/Edit'
import FilterList from '@material-ui/icons/FilterList'
import FirstPage from '@material-ui/icons/FirstPage'
import LastPage from '@material-ui/icons/LastPage'
import Remove from '@material-ui/icons/Remove'
import SaveAlt from '@material-ui/icons/SaveAlt'
import Search from '@material-ui/icons/Search'
import ViewColumn from '@material-ui/icons/ViewColumn'

// Custom Component
import useLoading from "../Loading/useLoading"
// import FullScreenDialog from '../Dialog/FullScreenDialog'

// Custom Style
import {defaultContentFont, defaultContentHeaderFont, defaultMainHeaderFont, whiteColor, grayColor, blueColor, nightOrangeColor, oceanBlueColor, DodgerBlueColor} from '../../styles/jss/cmsMainStyle'
import drawingHistoryTableStyle from '../../styles/jss/components/drawingRegister/drawingHistoryTableStyle'

// Fetch Data


const useStyles = makeStyles(theme => drawingHistoryTableStyle(theme))

const DrawingRevisionTable = props => {
	const {historyRecord} = props
	const store = require('store')
	const classes = useStyles()

	// State Variable
	const [selectedRow, setSelectedRow] = useState(null)
	const [dataTableToolbarOpen, setDataTableToolbarOpen] = useState(false)


	const tableIcons = {
		Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
		Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
		Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
		Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
		DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
		Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
		Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
		Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
		FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
		LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
		NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
		PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
		ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
		Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
		SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
		ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
		ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
	}


	const columns = [
		{title: "Action Code", field: "action_code", width: "10%"},
		{title: "Action Description", field: "action_desc", width: "70%"},
		{title: "Create By", field: "createuser", width: "10%"},
		{title: "Create Date", field: "createdate", width: "10%"},
	]


	useEffect(() => {

	}, [])



	return (
		// console.log("History Record | Variable: historyRecord (DrawingHistoryTable.js)"),
		// console.log(historyRecord),

		// console.log("DWG Type Group Selected Value | Variable: value (DataTable.js)"),
		// console.log(value),

		// console.log("DWG Type Group input Value | Variable: inputValue (DataTable.js)"),
		// console.log(inputValue),

		// console.log("---------------------------------------------------------------------------------"),


		<Fragment>
			<MaterialTable
				icons={tableIcons}
				title=""
				columns={columns}
				data={historyRecord}

				actions={[]}

				// onSelectionChange={(data) => {

				// }}

				// onSearchChange={handleSearchChange}
				// onFilterChange={handleFilterChange}

				// onRowClick={(event, selectedRow) => {

				// }}
				
				localization={{
					header : {
						actions: ""
					}
				}}

				options={{
					showTitle: false,
					toolbar: dataTableToolbarOpen,
					grouping: true,
					paging: false,
					selection: false,

					search: false,
					filtering: false,

					headerStyle: {
						backgroundColor: oceanBlueColor[10],
						fontFamily: "Gill Sans, sans-serif",
						fontWeight: "bold",
						fontSize: "16px",
						// color: grayColor[8],
						color: whiteColor,
					},

					rowStyle: rowData => ({
						backgroundColor: selectedRow === rowData.tableData.id ? oceanBlueColor[0] : "",
						fontSize: "14px",
						fontFamily: "Gill Sans, sans-serif",
					}),

					// cellStyle: { 
					// 		// backgroundColor: '#039be5',
					// 	fontFamily: "Gill Sans, sans-serif",
					// 		// color: '#FFF',
					// 		// height: 200,
					// 		// maxHeight: 200
					// 	}
				}}
			/>
		</Fragment>
	)
}


export default DrawingRevisionTable